import React, { useEffect, useRef } from 'react';

export const MFA_CODE_LENGTH = 6;

type Props = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const MfaCodeInput: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!disabled) inputRef.current?.focus();
  }, [disabled]);

  return (
    <label className={`MfaCodeInput ${disabled ? 'Disabled' : ''}`}>
      <input
        ref={inputRef}
        className="MfaCodeField"
        type="text"
        value={value}
        onChange={(e) =>
          onChange(e.target.value.replace(/\D/g, '').slice(0, MFA_CODE_LENGTH))
        }
        disabled={disabled}
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={MFA_CODE_LENGTH}
        aria-label="Verification code"
      />
      <span className="MfaCodeBox" aria-hidden="true">
        {Array.from({ length: MFA_CODE_LENGTH }).map((_, index) => (
          <span
            key={index}
            className={`Slot ${index === value.length ? 'Next' : ''}`}
          >
            {value[index] ?? <span className="Dot" />}
          </span>
        ))}
      </span>
    </label>
  );
};
